import React, { useState } from "react";
import { useStandard } from "../../../context/StandardContext";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ViewTableIndex from "../../../components/View/ViewTableIndex";
import UseGetData from "../../../hooks/useFetchData";
import { PaperClip } from "../../../assets/icons";
import NuDateFormat from "../../../utils/NuDate";
import useGetStatusData from "../../../hooks/useGetStatusData";
import useDashboardStatus from "../../../hooks/useDashboardStatus";
import CreateOrEdit from "./from";
import ViewMore from "./viewMore";
import CommonXlsExport from "../../../utils/CommonXlsExport";
import useGetStandardDetail from "../../../hooks/useGetStandardDetail";
import CommonImport from "../../../utils/CommonImport";
import useGetDropDown from "../../../hooks/useFetchDropDown";
import CommomApproval from "../../../utils/CommomApproval";
import { GetAccess } from "../../../utils/RolesandAccess";

function TrainingCalendarIndex() {
  const ModelId = 16;
  const { standardName } = useStandard();
  const { stdId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  let { statusFilter } = location?.state || "";
  const { statusValue } = useGetStatusData({ value: ModelId });
  const { dropDownValue } = useGetDropDown({
    url: `/Frequency/`,
    value: "frequency_type",
  });
  const {
    completePercentage,
    getData: getDashboardData,
    isReveiw,
  } = useDashboardStatus({
    url: `/DashBoard/standard/${stdId}/training-calender/`,
  });
  const [showMyModal, setShowMyModal] = useState(false);
  const handleOnClose = () => setShowMyModal(false);
  const [pageIndex, setPageIndex] = useState(1);
  const [dataCount, setDataCount] = useState(20);
  const { data, totalCount, getData, isLoading } = UseGetData({
    url: statusFilter
      ? `/Training-Calender/standard/${stdId}/status/${statusFilter}`
      : `/Training-Calender/standard/${stdId}/`,
    page: pageIndex,
    pageCount: dataCount,
  });
  const { standardDetailName, standardStartDate, standardEndDate } =
    useGetStandardDetail({ id: stdId });
  const [showExport, setShowExport] = useState(false);
  const [showImport, setShowImport] = useState(false);
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const handleApprovalOnClose = () => setShowApprovalModal(false);

  function clearFilter() {
    getData();
    navigate(".", { replace: true, state: { statusFilter: null } });
  }

  return (
    <>
      <ViewTableIndex
        label="Training Calendar"
        menu="Information"
        standardName={standardName}
        total={totalCount}
        setDataCount={setDataCount}
        dataCount={dataCount}
        pageIndex={pageIndex}
        setPageIndex={setPageIndex}
        setOpenForm={setShowMyModal}
        Access="information_create"
        hasOverAll={true}
        OverAllPercentage={completePercentage}
        header={header}
        isLoading={isLoading}
        ExportAccess="export"
        ExportFunction={() => setShowExport(true)}
        hasExport={true}
        ImportAccess="import"
        ImportFunction={() => setShowImport(true)}
        hasImport={true}
        hasFilter={true}
        filterValue={statusFilter}
        clearFunction={clearFilter}
        hasApprove={true}
        ReviewStatus={isReveiw}
        ReviewFunction={() => setShowApprovalModal(true)}
      >
        <>
          {data &&
            data?.map((data, i) => (
              <tr
                className="odd:bg-tableodd even:bg-tableeven text-xs 2xl:text-sm py-1 flex justify-between items-center my-1"
                key={i}
              >
                <td className="px-2 py-1 text-gray-900 whitespace-nowrap text-center w-[5%] capitalize">
                  {data.serial_number || "#"}
                </td>
                <td className="px-2 py-1 text-center text-gray-900 w-[12%] capitalize ">
                  {data?.training_program || "-"}
                </td>
                <td className="px-2 py-1 text-center text-gray-900 w-[11%] capitalize ">
                  {data?.function_responsibility || "-"}
                </td>
                <td className="px-2 py-1 text-center text-gray-900 w-[10%] capitalize ">
                  {data?.frequency || "-"}
                </td>
                <td className="px-2 py-1 text-center text-gray-900 w-[11%] capitalize ">
                  {data?.participants || "-"}
                </td>
                <td className="px-2 py-1 text-center text-gray-900 w-[12%] capitalize ">
                  {data?.mandatory || "-"}
                </td>
                <td className="px-2 py-1 text-center text-gray-900 w-[10%] capitalize ">
                  {data?.detail_plan || "-"}
                </td>
                <td className="px-2 py-1 text-center text-gray-900 w-[10%] capitalize ">
                  {(data?.planned_date !== "None" &&
                    data?.planned_date !== " " &&
                    NuDateFormat({
                      value: data?.planned_date,
                      format: "DD-MMM-yyyy",
                    })) ||
                    "-"}
                </td>
                <td className="px-2 py-1 text-center text-gray-900 w-[8%] capitalize flex justify-center items-center">
                  {data?.artifact.length > 0 && <PaperClip />}
                </td>
                <td className="px-2 py-1 text-center capitalize text-gray-900 w-[8%] ">
                  {data?.status || "-"}
                </td>
                <td className="px-2 py-1 w-[3%] flex justify-center items-center">
                  <ViewMore
                    data={data}
                    metaData={dropDownValue}
                    satusData={statusValue}
                    fetcher={getData}
                    getCompletion={getDashboardData}
                    id={stdId}
                  />
                </td>
              </tr>
            ))}
        </>
      </ViewTableIndex>
      <CreateOrEdit
        visible={showMyModal}
        onClose={handleOnClose}
        refreshData={getData}
        metaData={dropDownValue}
        satusData={statusValue}
        getCompletion={getDashboardData}
        id={stdId}
      />

      {GetAccess("export") && (
        <CommonXlsExport
          id={stdId}
          path={`training_calender`}
          name={`${standardDetailName} Training Calender ${
            standardStartDate &&
            NuDateFormat({ value: standardStartDate, format: "MMM-YYYY" })
          } ${standardEndDate && "to"} ${
            standardEndDate &&
            NuDateFormat({ value: standardEndDate, format: "MMM-YYYY" })
          }`}
          visible={showExport}
          onClose={() => {
            setShowExport(false);
          }}
        />
      )}
      {GetAccess("import") && (
        <CommonImport
          url={`/Training-Calender/standard/${stdId}/import/`}
          refreshData={getData}
          getFuction={getDashboardData}
          visible={showImport}
          onClose={() => setShowImport(false)}
          hasRemoveApproval={true}
          moduleId={ModelId}
          standardId={stdId}
        />
      )}

      {GetAccess("review_and_approve") && (
        <CommomApproval
          visible={showApprovalModal}
          onClose={handleApprovalOnClose}
          refreshData={getData}
          moduleId={ModelId}
          id={stdId}
          moduleName="Training Calendar"
          standardName={standardDetailName}
          getCompletion={getDashboardData}
        />
      )}
    </>
  );
}

export default TrainingCalendarIndex;

const header = [
  {
    headone: <span>Sl&nbsp;No.</span>,
    width: "w-[5%]",
  },
  {
    headone: "Training Program",
    width: "w-[12%]",
  },
  {
    headone: "Function Responsibility",
    width: "w-[11%]",
  },
  {
    headone: "Frequency",
    width: "w-[10%]",
  },
  {
    headone: "Participants",
    width: "w-[11%]",
  },
  {
    headone: "Mandatory for the organization",
    width: "w-[12%]",
  },
  {
    headone: "Detail Plan",
    width: "w-[10%]",
  },
  {
    headone: "Planned Date",
    width: "w-[10%]",
  },
  {
    headone: "Artefact",
    width: "w-[8%]",
  },
  {
    headone: "Status",
    width: "w-[8%]",
  },
  {
    headone: "",
    width: "w-[3%]",
  },
];
